import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { Rect } from '@view-model/models/common/basic/Rect';
import type { Viewer } from '../Viewer';
import { useFollowingUser } from '../useFollowingUser';
import { ViewerPopupContent } from './ViewerPopupContent';

type Props = {
  viewers: Viewer[];
  setClientViewBox: (viewBox: Rect) => void;
};

export const ViewerPopup: React.FC<Props> = ({ viewers, setClientViewBox }: Props) => {
  const { t } = useTranslation();
  const { followingUserId } = useFollowingUser();

  // フォロー中のユーザーを先頭に配置
  const sortedViewers = useMemo(() => {
    if (!followingUserId) return viewers;

    const followingViewer = viewers.find((v) => v.userId === followingUserId);
    if (!followingViewer) return viewers;

    const others = viewers.filter((v) => v.userId !== followingUserId);
    return [followingViewer, ...others];
  }, [viewers, followingUserId]);

  return (
    <>
      <div className="cursor-default px-3 py-2">{t('canvas.viewer.popup.totalViewers', { count: viewers.length })}</div>
      {sortedViewers.map((viewer) => (
        <ViewerPopupContent key={viewer.userId} viewer={viewer} setClientViewBox={setClientViewBox} />
      ))}
    </>
  );
};
